import styled from 'styled-components';

import OriginalModal from 'components/Modal';
import { red, grey200 } from 'styles/colors';

export const Modal = styled(OriginalModal)`
	button[type='submit'] {
		color: ${red};
		&:disabled {
			color: ${grey200};
		}
	}
`;

export const Text = styled.div`
	ul {
		padding: 10px 10px 10px 40px;
	}

	li {
		list-style: initial;
	}
`;